export default __webpack_public_path__ + "static/media/slider2.3639d4af.jpg";